<template>
	<div>
		<button
			type="button"
			:class="classButton"
			@click="showHiddenFields = !showHiddenFields"
		>
			{{ label }}
		</button>
		<div :class="classContent">
			<FormulateSchema
				v-if="showHiddenFields"
				:schema="hiddenElements"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: { type: String, required: true },
		label: { type: String, required: true },
		classButton: { type: String, required: false, default: 'btn btn-primary' },
		classContent: { type: String, required: false, default: 'mt-3' },
		hiddenElements: { type: Array, required: true },
	},
	data() {
		return {
			showHiddenFields: false,
			errors: {},
			value: null,
		};
	},
};
</script>
